import AttachItemsToInvoiceHtml           from './templates/attach.items.to.invoice.html';
import VendorInvoiceAcquisitionCreditHtml from './vendor-invoice.acquisition-credit.html';
import VendorInvoiceAcquisitionHtml       from './vendor-invoice.acquisition.html';
import WindowFlipHtml                     from '../../app-lite/core/templates/window-flip.html';

/**
 * Handles all business rules for vendor invoices. Totals, saves, processing and
 * other activities (TODO) all come from here
 */
export function VendorInvoicesService (
  $q,
  $state,
  $translate,
  $uibModal,
  $window,
  API,
  confirm,
  jsonApi,
  messages,
  pruneApi,
  sessionObjAPI,
  VendorInvoiceTotals,
  tableApi,
  workshopAPI
) {
  const VendorInvoice = function (invoice) {
    if (invoice) {
      this.invoice = invoice;
      this.form    = {};
      this.totals  = new VendorInvoiceTotals(invoice);

      this.initialize();
    }
  };

  /**
   * Before we do any saves, the array of items to delete
   * needs to be added to the list of items. Also, we need
   * to remove all untouched items
   * @param  {object} invoice Invoice to prepare for save
   * @return {object}         Assembled invoice
   */
  const assemble = function (invoice) {
    var invoice = jsonApi.copy(invoice);

    invoice.vendor_invoice_items_attributes = pruneApi.removeUntouched(invoice.vendor_invoice_items_attributes);
    invoice.vendor_invoice_items_attributes = invoice.vendor_invoice_items_attributes.concat(invoice.itemsToDelete);

    return $q.when(invoice);
  };

  VendorInvoice.prototype.launchAcquisitionModal = function () {
    return $uibModal.open({
      controller       : 'AcquisitionCtrl',
      templateUrl      : VendorInvoiceAcquisitionHtml,
      windowClass      : 'product-search-modal flip-container',
      windowTemplateUrl: WindowFlipHtml,
      resolve          : {
        bodyTypes        : [ 'workshopAPI', workshopAPI => workshopAPI.get('/system/vehicle_body_types/', null, 'bodyTypes')],
        driveTypes       : [ 'workshopAPI', workshopAPI => workshopAPI.get('/system/drive_types/', null, 'driveTypes')],
        franchises       : [ 'workshopAPI', workshopAPI => workshopAPI.get('/vehicle_group_or_franchise_types')],
        fuelTypes        : [ 'workshopAPI', workshopAPI => workshopAPI.get('/system/fuel_types/', null, 'fuelTypes')],
        templates        : [ 'workshopAPI',  workshopAPI => workshopAPI.get('/vehicle_templates', [ 0, 11, 'find_description', 'asc' ])],
        transmissionTypes: [ 'workshopAPI', workshopAPI => workshopAPI.get('/system/transmission_types/', null, 'transmissionTypes')]
      }
    }).result;
  };

  VendorInvoice.prototype.launchAcquisitionCreditModal = function () {
    var self = this;

    return $uibModal.open({
      templateUrl      : VendorInvoiceAcquisitionCreditHtml,
      windowClass      : 'product-search-modal flip-container',
      windowTemplateUrl: WindowFlipHtml,
      controller       : 'AcquisitionCreditCtrl',
      resolve          : {
        invoices: [ 'workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/vendor_invoices/acquisition_invoices_for_vendor', [ self.invoice.vendor_id, 0, 11 ]);
        }],
        vendorID: [ function () {
          return self.invoice.vendor_id;
        }]
      }
    }).result;
  };

  VendorInvoice.prototype.initialize = function () {
    var self = this;

    angular.forEach(self.invoice.vendor_invoice_items_attributes, function (item) {
      item.display_cost = self.invoice.price_includes_tax ? item.cost_including_tax: item.cost;
    });
  };

  VendorInvoice.prototype.attachItemsToInvoice = function (items) {
    const cache = tableApi.getCacheForTable('vendorInvoiceItemsAttach');

    var company    = sessionObjAPI.company();
    var orderItems = [];
    var regoLabel  = sessionObjAPI.countrySettings().rego_label;

    if (company.company_variable_fields.plate_number_name != '') {
      var regoLabel = company.company_variable_fields.plate_number_name;
    }
    else {
      var regoLabel = sessionObjAPI.countrySettings().rego_label;
    };

    angular.forEach(items, function (item) {
      orderItems.push(item.id);
    });

    return $uibModal.open({
      templateUrl: AttachItemsToInvoiceHtml,
      windowClass: 'product-search-modal',
      controller : 'AttachItemsToInvoiceCtrl',
      resolve    : {
        invoices: [ function () {
          return workshopAPI.get('/invoices/invoice_list_for_linking', [0, cache.paging.pageSize || 5, 'O', 'I-U', 'job_card_number', 'desc', '*']);
        }]
      }
    }).result.then(function (invoice){
      return workshopAPI.post('/invoices/create_invoice_item_from_vendor_invoice_item', {vendor_invoice_items: orderItems, invoice_id: invoice.id});
    });
  };

  VendorInvoice.prototype.delete = function() {
    var self = this;

    return confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_INVOICE'))
      .then(function () {
        return workshopAPI.delete('/vendor_invoice', self.invoice.id);
      }).then(function () {
        self.form.$setPristine();
        $state.go('app');

        return;
      });
  };

  VendorInvoice.prototype.getCopy = function () {
    var self = this;
    var copy = sessionObjAPI.get('vendor_invoice_copy');

    if (copy) {
      self.invoice = copy;
      self.form = {};
      self.totals = new VendorInvoiceTotals(copy);

      sessionObjAPI.setKey('vendor_invoice_copy', null);
    }

    return copy ? copy : null;
  };

  /**
   * Determines if an invoice is the specified type
   * @param  {string} type "credit", "invoice" or "quote"
   * @return {boolean}      whether or not the invoice is the specified type
   */
  VendorInvoice.prototype.type = function (type) {
    var self = this;
    var typeMap = {
      credit : 'C',
      quote  : 'Q',
      invoice: 'I'
    };

    return typeMap[type] === self.invoice.invoice_type;
  };

  /**
   * Determines if an invoice is currently in a specified status
   * @param  {string} status "open", "closes" or "processed"
   * @return {boolean}        whether or not the invoice's status matches the specified one
   */
  VendorInvoice.prototype.status = function (status) {
    var self = this;
    var statusMap = {
      open     : 'O',
      closed   : 'C',
      processed: 'P'
    };

    return statusMap[status] === self.invoice.invoice_status;
  };

  /**
   * Handles all validation on the vendor invoice.
   * Validates the form and then throws a specialized error if it
   * is invalid
   * @return {promise} The invoice if valid, nothing if invalid
   */
  VendorInvoice.prototype.validate = function () {
    var self = this;
    var deferred = $q.defer();

    if (self.form.$valid) {
      deferred.resolve(self.invoice);
    }
    else {
      messages.clientError(self.form);
      deferred.reject();
    }

    return deferred.promise;
  };

  VendorInvoice.prototype.closed = function() {
    var self = this;

    return self.invoice.invoice_status && self.invoice.invoice_status !== 'O';
  };

  /**
   * After all saves, certain actions need to take place no matter what.
   * They are hadnled here
   * @param  {object} invoice newly saved invoice
   * @return {promise}         The new invoice
   */
  VendorInvoice.prototype.cleanup = function (invoice, options) {
    var self = this;
    var deferred = $q.defer();

    // Set the invoice in the class to the new invoice
    self.invoice = invoice;

    // Set the form to pristine so page changes can happen without warning
    self.form.$setPristine();

    if (!options || !options.skipRefresh) {

      // Redirect to page with new id from invoice
      $state.go('app.vendor-invoice', {
        acquisition_id: null,
        id            : invoice.id,
        vendor_id     : invoice.vendor_id
      }, { reload: true });
    }

    deferred.resolve(invoice);

    return deferred.promise;
  };

  /**
   * Saves the invoice after removing untouvhed items,
   * adding the items to be deleted and validating it.
   * @return {promise} The newly saved invoice or the error
   */
  VendorInvoice.prototype.save = function (options) {
    var self = this;
    var deferred = $q.defer();
    var url = self.invoice.id ? '/vendor_invoice': '/vendor_invoices';
    var method = self.invoice.id ? 'patch': 'post';

    self.validate().then(function () {
      return assemble(self.invoice);
    }).then(function (invoice) {
      return workshopAPI[method](url, invoice, 'vendor_invoice');
    }).then(function (invoice) {
      return self.cleanup(invoice, options);
    }).then(deferred.resolve, deferred.reject);

    return deferred.promise;
  };

  /**
   * Saves and processes the invoice after a confirmation,
   * validation, removing untouched items and adding in the
   * items to be deleted.
   * @return {promise} The newly processed invoice or the error
   */
  VendorInvoice.prototype.process = function () {
    var self = this;

    return confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_PROCESS_INVOICE')).then(function () {
      return self.validate();
    }).then(function () {
      return assemble(self.invoice);
    }).then(function (invoice) {
      return workshopAPI.patch('vendor_invoice/process_and_save', invoice, 'vendor_invoice');
    }).then(function (invoice) {
      return self.cleanup(invoice);
    });
  };

  VendorInvoice.prototype.checkVendorInvoiceNumber = function (oldCode, newCode, vendor_id) {
    return oldCode !== newCode ?
      workshopAPI.post('/vendor_invoice/verify_vendor_invoice_number_uniqueness', {vendor_invoice_number: newCode, vendor_id: vendor_id})
        .then(function (data) {
          return jsonApi.parse(data);
        }) : $q.when(true);
  };

  VendorInvoice.prototype.openReport = function (id) {
    $window.open(`${API.url}/reports/jasper_vendor_invoice/${id}.pdf`, '_blank');
  };

  return VendorInvoice;

}